import React, { useState } from "react";
import styles from "./index.module.css";
import classnames from "classnames";
import { statTrack } from "@/utils/mtstat";
import IconFont from "@meitu/xdesign-icon-font";
import { CardItem } from "@/constants/home";

interface CardModuleProps {
  cardList: CardItem[];
  title: string;
}

const CardModule = ({ cardList, title }: CardModuleProps) => {
  const [cur, setCur] = useState(0);
  return (
    <div className={styles.cardWrap}>
      <div className={styles.cardTitle}>{title}</div>
      <div className={styles.cardList}>
        <div className={styles.cardListLeft}>
          {cardList.map((item, index) => (
            <div
              className={classnames(styles.cardItem, {
                [styles.cardItemActive]: cur === index,
              })}
              key={item.statBtnKey}
              onMouseEnter={() => {
                setCur(index);
              }}
            >
              <div className={styles.cardItemText}>
                <div className={styles.cardItemTitle}>{item.title}</div>
                <div className={styles.cardItemDesc}>{item.desc}</div>
              </div>
              <a
                className={styles.cardItemBtn}
                href={item.url}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  statTrack("tools_click_ppt_home", {
                    click_type: "intro_create",
                    intro_create_button: item.statBtnKey,
                  });
                  setTimeout(() => {
                    window.location.href = item.url;
                  }, 100);
                }}
              >
                生成
                <IconFont
                  fontSize={14}
                  className={styles.cardItemBtnIcon}
                  name="ForwardArrowBold"
                  color="#fff"
                />
              </a>
            </div>
          ))}
        </div>
        <div className={styles.cardListRight}>
          {cardList.map((item, index) => (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              src={item.img}
              className={classnames(styles.cardImg, {
                [styles.cardImgActive]: index === cur,
              })}
              key={item.title}
              alt=""
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CardModule;
